import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { QuoteProductVisisbilityPolicyListView } from 'src/app/bookings/quote-product-visibility-policies/list/quote-product-visibility-policy-list.view';
import { QuoteProductVisibilityPolicyListDataService } from 'src/app/bookings/quote-product-visibility-policies/list/quote-product-visibility-policy-list.data';

@observer
export class QuoteProductVisibilityPolicyListController extends React.Component<ControllerProps<any>, {}> {
	@observable
	private dataService: QuoteProductVisibilityPolicyListDataService;

	@resolve
	private toast: ToastNotifications;

	public componentDidMount() {
		this.props.setBusy(true);
		this.loadData()
			.then(() => {
				this.props.setBusy(false);
			})
			.catch((error) => {
				this.props.setBusy(false);
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			});
	}

	public render() {
		if (this.dataService == null || this.dataService.items == null) {
			return null;
		}

		return (
			<QuoteProductVisisbilityPolicyListView
				model={this.dataService}
				setBusy={this.props.setBusy}
				onItemDoubleClicked={this.handleItemDoubleClicked}
			/>
		);
	}

	private async loadData(): Promise<void> {
		this.dataService = QuoteProductVisibilityPolicyListDataService.make();

		this.dataService.pageSize = 20;
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
		await this.dataService.load((query) => query);
	}

	private handleItemDoubleClicked = (item?: QuotePolicySummary): void => {
		this.props.history.push(`/bookings/quote-product-visibility-policies/${item == null ? 'new' : item.id}`);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-product-visibility-policies/list/quote-product-visibility-policy-list.controller.tsx